import { render, staticRenderFns } from "./TimeDelta.vue?vue&type=template&id=9e96c9ec&lang=pug"
import script from "./TimeDelta.vue?vue&type=script&lang=ts"
export * from "./TimeDelta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports